import styles from "./styles.module.css";
import Card from "../Card";

const CoCoCard = ({ icon, title, info, buttonLabel, handleProceed }) => {
  return (
    <Card className={styles["card-content"]}>
      <div className={styles["info-container"]}>
        <img src={icon} height={66} alt="Online Coco Icon"/>
        <p className={styles["coco-card-title"]}>{title}</p>
        <p className={styles["coco-card-info"]}>{info}</p>
      </div>
      {buttonLabel && (
        <button
          className={`btn-primary ${styles["proceed"]}`}
          onClick={handleProceed}
        >
          {buttonLabel}
        </button>
      )}
    </Card>
  );
};

export default CoCoCard;
